<template>
  <b-row>
    <b-col
      cols="12"
      md="12"
    >
      <h5>Preço</h5>
    </b-col>

    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        label="Tabela de Preço"
        label-for="tabela_preco"
      >
        <v-select
          v-model="itemData.id_tabela_preco"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="optionsTabelaPreco"
          label="descricao"
          disabled
          :reduce="val => val.id"
          :clearable="false"
          input-id="tabela_preco"
        />
      </b-form-group>
    </b-col>

    <b-col
      cols="12"
      md="6"
    >

      <label for="">Preço</label>
      <b-input-group
        size="md"
        prepend="R$"
      >
        <b-form-input
          v-model="itemData.preco_venda"
          type="number"
          disabled
          :number-of-decimals="2"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :placeholder="$store.state.appConfig.isRTL ? '0,00' : '0.00'"
          :step="0.01"
          :options="optionsMask.number"

        />

      </b-input-group>
    </b-col>

  </b-row>

</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
} from 'bootstrap-vue'
import {ref, onMounted, watch} from '@vue/composition-api'
import VSelect from 'vue-select'
import useOptionsMask from '@/composables/useOptionsMask'
import { useApi } from '@/composables/useApi'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    VSelect,
  },
  model: {
    prop: 'itemData',
    event: 'handleSubmit',
  },
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { optionsMask } = useOptionsMask()
    const optionsTabelaPreco = ref([])
    const api = useApi()

    watch(props.itemData, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        console.log('newValue', newValue)
      }
    })

    onMounted(async () => {
      await api.get('/tabela-precos')
        .then(response => {
          optionsTabelaPreco.value = response.data.tabela_precos
        })
    })
    return {
      optionsMask,
      optionsTabelaPreco,
    }
  },
}
</script>

<style scoped>
</style>
